import Swiper from 'swiper';
import { Navigation, EffectFade } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function() {
    // Check if element exists before initializing Swiper
    const swiperElement = document.querySelector('.system-swiper');
    if (!swiperElement) {
        return;
    }
    
    let systemSwiper;
    
    // Function to manage button disabled states
    function updateButtonStates() {
        // Check if swiper is initialized and has slides
        if (!systemSwiper || !systemSwiper.slides || systemSwiper.slides.length === 0) {
            return;
        }
        
        const prevButton = document.querySelector('.system-block__navigation .swiper-button-prev');
        const nextButton = document.querySelector('.system-block__navigation .swiper-button-next');
        
        if (prevButton) {
            if (systemSwiper.activeIndex === 0) {
                prevButton.classList.add('swiper-button-disabled-custom');
            } else {
                prevButton.classList.remove('swiper-button-disabled-custom');
            }
        }
        
        if (nextButton) {
            if (systemSwiper.activeIndex === systemSwiper.slides.length - 1) {
                nextButton.classList.add('swiper-button-disabled-custom');
            } else {
                nextButton.classList.remove('swiper-button-disabled-custom');
            }
        }
    }
    
    systemSwiper = new Swiper('.system-swiper', {
        modules: [Navigation, EffectFade],
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 800,
        loop: false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        watchOverflow: false,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        allowTouchMove: true,
        navigation: {
            nextEl: '.system-block__navigation .swiper-button-next',
            prevEl: '.system-block__navigation .swiper-button-prev',
            disabledClass: 'swiper-button-disabled-custom',
        },
        
        // Ensure images are loaded correctly
        on: {
            init: function() {
                this.update();
                
                // Force navigation update to ensure disabled states are applied
                if (this.navigation) {
                    this.navigation.update();
                }
                
                // Small delay to ensure Swiper is fully initialized
                setTimeout(() => {
                    updateButtonStates();
                }, 100);
            },
            imagesReady: function() {
                this.update();
                
                // Force navigation update after images are loaded
                if (this.navigation) {
                    this.navigation.update();
                }
                
                updateButtonStates();
            },
            slideChange: function() {
                updateButtonStates();
            }
        }
    });
});
